import { SAVE_TECHNICIAN_DATA, DELETE_TECHNICIAN_DATA } from "../../Constants";
import {
  saveLocalTechData,
  fetchLocalTechData,
} from "../../Api/Utils/ReuseableFunctions";
function addUserData(data) {
  return {
    type: SAVE_TECHNICIAN_DATA,
    data,
  };
}
function deleteUserData(data) {
  return {
    type: DELETE_TECHNICIAN_DATA,
    data,
  };
}

export const userDataTech = (payload) => (dispatch) => {
  saveLocalTechData(payload);
  dispatch(addUserData(payload));
};
export const deleteUserDataTech = (payload) => (dispatch) => {
  dispatch(deleteUserData(payload));
};
export const fetchLocalData = () => (dispatch) => {
  let payload = fetchLocalTechData();
  dispatch(addUserData(payload));
};
